"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMemberFromArgs = exports.memberRolesSchema = void 0;
var suretype_1 = require("suretype");
exports.memberRolesSchema = suretype_1.v.anyOf([
    suretype_1.v.string().enum("administrator", "moderator"),
    suretype_1.v.null()
]);
function createMemberFromArgs(user, role, name) {
    var _a;
    var now = new Date().getTime();
    return {
        details: {
            name: name ? name : (_a = user.name) !== null && _a !== void 0 ? _a : "Incognito",
            docTimestamp: now,
            licenses: {}
        },
        // filter
        status: "active",
        role: role,
        communityMuted: false,
        // sort
        totalReward: 0,
        joinedOn: now,
        lastActive: now
    };
}
exports.createMemberFromArgs = createMemberFromArgs;
